<script setup lang="ts">
import placeholderMap from '~/assets/images/placeholder-map.svg';
</script>

<template>
  <div>
    <img
      :src="placeholderMap"
      class="h-full w-full object-cover rounded-lg sm:rounded-2xl"
    >
  </div>
</template>
